import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';

// TSS vite/03 — Avalúos (valor de inventario) genéricos por SUJETO (0098/0108). `kind`:
//   'animals'     → cría nacida o vaca adulta (por animal_id)
//   'pregnancies' → preñez confirmada = cría futura (por pregnancy_id)
// Rutas espejo: /admin/{kind}/:id/valuations (+ /:vid). GET kpis:read · POST/PATCH/DELETE
// animals:write. Nutre el indicador económico offspring_inventory de la donadora (solo status=2).
const base = (kind, id) => `admin/${kind}/${id}/valuations`;
const key = (kind, id) => ['valuations', kind, id];

function invalidate(qc, kind, id) {
    qc.invalidateQueries({ queryKey: key(kind, id) });
    qc.invalidateQueries({ queryKey: ['stats'] }); // el económico usa el último avalúo
}

// GET → { items (historial), latest (valor actual) }.
export function useValuations(kind, id) {
    return useQuery({
        queryKey: key(kind, id),
        queryFn:  ({ signal }) => api.get(base(kind, id), { signal }).then(r => r.data),
        enabled:  !!kind && !!id,
    });
}

export function useCreateValuation(kind, id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(base(kind, id), payload).then(r => r.data),
        onSuccess:  () => invalidate(qc, kind, id),
    });
}

// PATCH /:vid — parche parcial (incl. `cause`, 0108).
export function useUpdateValuation(kind, id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ vid, payload }) => api.patch(`${base(kind, id)}/${vid}`, payload).then(r => r.data),
        onSuccess:  () => invalidate(qc, kind, id),
    });
}

// DELETE /:vid — soft-delete (status=0).
export function useDeleteValuation(kind, id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (vid) => api.delete(`${base(kind, id)}/${vid}`).then(r => r.data),
        onSuccess:  () => invalidate(qc, kind, id),
    });
}
